import { Fragment, useState } from "react";
import { Col, Form } from "react-bootstrap";
import style from "./ContentShop.module.css";
import { RxCross1 } from "react-icons/rx";
import { FaPlus } from "react-icons/fa";
import generateRandomString from "../../functions/generateRandomString";

function ContentShop({ register, errors, index, content, unregister }) {
  const [list, setList] = useState(content);

  const errorMessage = idx => {
    try {
      if (errors.content[idx].name) {
        return <p>{errors.content[idx].name.message}</p>;
      }
      if (errors.content[idx].total) {
        return <p>{errors.content[idx].total.message}</p>;
      }
    } catch (error) {
      return <Fragment></Fragment>;
    }
  };

  return (
    <section className="w-100 px-2 mb-3">
      <Form.Label>
        <span>محتویات: </span>
        <button
          className={"buttonUi " + style.plus}
          type="button"
          onClick={() =>
            setList(cur => [...cur, { key: generateRandomString() }])
          }
        >
          <FaPlus />
        </button>
      </Form.Label>

      <div className="d-flex flex-wrap column-gap-3 row-gap-3">
        {list.map((item, idx) => (
          <Col key={item.key} xs={12} sm={6} lg={4} xl={3} xxl={2}>
            <div className={style.box}>
              <input
                type="text"
                className={style.name}
                {...register(`items.${index}.content.${idx}.name`, {
                  required: { value: true, message: "محتویات الزامی" },
                })}
                placeholder="مثل: کیف"
              />
              <input
                type="number"
                {...register(`items.${index}.content.${idx}.total`, {
                  required: { value: true, message: "تعداد محتویات الزامی" },
                })}
                className={style.total}
                placeholder="تعداد: 1"
              />

              <input
                type="number"
                {...register(`items.${index}.content.${idx}.key`, {
                  value: item.key,
                })}
                className={style.hidden}
              />

              <button
                className={"buttonUi " + style.delete}
                type="button"
                onClick={() =>
                  setList(cur => {
                    if (cur.length === 1) return [...cur];
                    unregister(`items.${index}.content`);
                    return cur.filter(itm => itm.key !== item.key);
                  })
                }
              >
                <RxCross1 />
              </button>
            </div>
            {errorMessage(idx)}
          </Col>
        ))}
      </div>
    </section>
  );
}

export default ContentShop;
